import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import {
  Chip,
  ChipProps,
  CircularProgress,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import moment from "moment";
import { formatLocalDateTime } from "../../../../../utilis/methods/localDateTime";
import { Cancel, Print } from "@mui/icons-material";
import { FormOnChangeEventType } from "../../../../../EMR/types";
import { getappointmentPayloadType } from "../../../../../MainDashboard/Reception/components/appointments/type";
import {
  deleteCashierService,
  getPaidListServicepartial,
  getPrintService,
  getPrintServicev2New,
} from "../../Service";
import debounce from "../../../../../utilis/methods/networkHandling";
import { paidListType } from "../../type";
import usePrint from "../../../../../hooks/usePrint";
import usePopup from "../../../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
import { useRef } from "react";
import { grey } from "@mui/material/colors";

const PaidList = () => {
  const { control } = useForm({
    defaultValues: {
      searchDate: moment().format("YYYY-MM-DD"),
    },
  });
  const { user } = useAuthentication();
  const { printPdf } = usePrint();
  const { showSnackbar } = usePopup();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const checkBillNo = useRef<{[key:string]:number}>({})
  const [searchPayload, setSearchPayload] = useState<getappointmentPayloadType>(
    {
      clinicId: 1,
      filter: {
        search: "",
        searchDate: moment().format("YYYY-MM-DD"),
      },
      pageNumber: 1, // backend expects 1-based
      pageSize: 25,
      sortField: "",
      sortOrder: "asc",
    },
  );

  const {
    mutate: getPadiList,
    data: PaidList,
    isLoading,
  } = useMutation(getPaidListServicepartial);

  useEffect(() => {
    getPadiList(searchPayload);
  }, [searchPayload]);

  // âœ… handle rows per page change
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 1, // reset to first page when page size changes
      pageSize,
    }));
  };

  // âœ… handle page change (MUI uses 0-based; backend expects 1-based)
  const handleChangePage = (_: unknown, newPage: number) => {
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: newPage + 1, // adjust for backend
    }));
  };

  // âœ… search debounce
  const searchOnText = debounce((e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 1, // reset to page 1 on new search
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  }, 500);

  const searchAppointments = (e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 1,
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const { mutate: getprint, isLoading: printLoading } = useMutation(
    getPrintService,
    {
      onSuccess: (data: any) => {
        printPdf(data.response);
      },
    },
  );

  const { mutate: getprintv2, isLoading: printLoadingv2 } = useMutation(({ cashierId, cashSplitId }: { cashierId: number; cashSplitId: number }) => 
    getPrintServicev2New(cashierId, cashSplitId),
    {
      onSuccess: (data: any) => {
        printPdf(data.response);
      },
    },
  );

  const { mutate: deletePayment, isLoading: deleteLoading } = useMutation(
    deleteCashierService,
    {
      onSuccess: (data: any) => {
        if (data.responseIndicator === "success") {
          showSnackbar({
            message: "Payment Deleted Successfully",
            variant: "success",
            open: true,
            duration: 2000,
          });
          getPadiList(searchPayload);
        }
      },
    },
  );

  return (
    <>
      <form>
        <div className="grid grid-cols-12 gap-2 my-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="input"
              name="search"
              rules={{ required: false, onChange: searchOnText }}
              fieldProps={{ label: "Search", type: "text" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="datepicker"
              name="searchDate"
              dateFormat="YYYY-MM-DD"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "" }}
            />
          </div>
          {/* <div className="col-span-2">
                    <CustomFormField 
                    control={control}
                    element="autocomplete"
                    options={[{id:2,name:"All"},{id:1,name:"Insurance"},{id:0,name:"Cash"}]}
                    autocompleteProps={{getOptionLabel:(option)=>option.name,
                    isOptionEqualToValue:(option,value)=>option.id===value.id}}                             
                    name="type"
                    rules={{required:false ,onChange:searchAppointments}}
                    fieldProps={{label:" Payment Type"}}
                    />
             </div> */}
        </div>
      </form>

      <Table size="small">
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          <TableRow>
            {headings.map((item: string, index: number) => (
              <TableCell
                key={index}
                sx={(theme) => ({ color: theme.palette.background.paper })}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <CustomTableBody
          alert={"No Cashed items"}
          dataLoading={isLoading}
          isData={Boolean(PaidList?.response?.items.length)}
          totalSpan={{ col: headings.length, row: searchPayload.pageSize }}
        >
          {PaidList?.response?.items?.map(
            (item: paidListType, index: number) => {
            checkBillNo.current[item.billNo] == undefined && (checkBillNo.current[item.billNo] = index)
              const tableRowComponent = (
                (
                <TableRow key={index} sx={{backgroundColor: checkBillNo.current[item.billNo] == index ? "" : grey[300]}}>
                  <TableCell>
                    {(searchPayload.pageNumber - 1) * searchPayload.pageSize +
                      (index + 1)}
                  </TableCell>

                  <TableCell sx={{whiteSpace:"nowrap"}}>{formatLocalDateTime(item.date)}</TableCell>
                  <TableCell>{item.patientID}</TableCell>
                  <TableCell>{item?.billNo}</TableCell>
                  <TableCell>{item?.pname}</TableCell>
                  <TableCell>{item?.doctor}</TableCell>
                  <TableCell>{item?.amount?.toFixed(2)}</TableCell>
                  <TableCell>{item?.cashier}</TableCell>
                  <TableCell>{item?.totalPatShare?.toFixed(2)}</TableCell>
                  <TableCell>{item?.receivedAmount?.toFixed(2)}</TableCell>
                  <TableCell>{item?.modeOfPayment}</TableCell>
                  <TableCell>{item?.patDiscount?.toFixed(2)}</TableCell>
                  <TableCell>{item?.balance?.toFixed(2)}</TableCell>
                  <TableCell>
                    {(() => {
                      const isCancelled = item?.status !== 1;
                      const isFullyPaid =
                        Number(item?.amount || 0) ===
                        Number(item?.receivedAmount || 0) +
                          Number(item?.patDiscount || 0);

                      // Explicitly typing the color to match MUI's Chip color expectations
                      let label = "Partially Paid";
                      let chipColor: ChipProps["color"] = "info";

                      if (isCancelled) {
                        label = "Cancelled";
                        chipColor = "error";
                      } else if (isFullyPaid) {
                        label = "Fully Paid";
                        chipColor = "success";
                      }

                      return (
                        <Chip
                          label={label}
                          color={chipColor} // TypeScript is now happy because chipColor matches the expected union
                          size="small"
                          variant="outlined"
                          sx={{
                            fontSize: "10px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            minWidth: "95px",
                            height: "24px",
                          }}
                        />
                      );
                    })()}
                  </TableCell>
                  <TableCell>
                    <div className="flex">
                      {item.status == 1 && (
                        <IconButton
                          onClick={() => {
                            setSelectedIndex(index);
                            user?.paymentmethod == "partial"
                              ? getprintv2({cashierId:item.cashierId,cashSplitId:item.cashierSplitId})
                              : getprint(item.cashierId);
                          }}
                        >
                          {(printLoading || printLoadingv2) &&
                            index === selectedIndex ? (
                            <CircularProgress
                              size={18}
                              sx={(theme: any) => ({
                                color: theme.palette.background.main,
                              })}
                            />
                          ) : (
                            <Print color="primary" />
                          )}
                        </IconButton>
                      )}
                      {item.status == 1 && (checkBillNo.current[item.billNo] == index) && (
                        <IconButton
                          disabled={
                            (isLoading || deleteLoading) && (index === selectedIndex)
                          }
                          onClick={() => {
                            setSelectedIndex(index);
                            deletePayment({
                              cashierId: item.cashierId,
                              paymentId: item.paymentId,
                              userId: Number(user?.login_id),
                              clinicId: user?.clinicId,
                            });
                          }}
                        >
                          {(isLoading || deleteLoading) &&
                            index === selectedIndex ? (
                            <CircularProgress
                              size={18}
                              sx={(theme: any) => ({
                                color: theme.palette.error.main,
                              })}
                            />
                          ) : (
                            <Cancel color="error" />
                          )}
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              )
              )
              return tableRowComponent;
            },
          )}
        </CustomTableBody>
      </Table>

      {/* âœ… Pagination with proper sync */}
      <TablePagination
        count={PaidList?.response?.totalCount || 0}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={searchPayload.pageSize}
        page={(searchPayload.pageNumber || 1) - 1} // convert for MUI display
      />
    </>
  );
};

export default PaidList;

const headings = [
  "SL No",
  "Date",
  "PatientId",
  "Invoice No",
  "PatientName",
  "Doctor",
  "Amount",
  "Cashier",
  "Patient Share",
  "Cash Received",
  "Mode of Payment",
  "Patient Discount",
  "Balance Amount",
  "Status",
  "Action",
];